import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { DatePicker, DatePickerProvider } from 'components/Custom/DatePicker'
import { DatePickerProps } from '@mui/x-date-pickers'

interface DateInputControllerProps<T extends FieldValues> extends DatePickerProps<Date> {
  control: Control<T>
  errorMessage?: string | undefined
  name: Path<T>
  label: string
  onBlur?: () => void
  title?: string
}

export const DateInputController = <T extends FieldValues>({
  control,
  errorMessage,
  name,
  label,
  title,
  onBlur,
  className,
  ...datePickerProps
}: DateInputControllerProps<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => {
        const dateValue = (() => {
          if (!value) return null
          if ((value as unknown) instanceof Date) return value as Date

          const [year, month, day] = String(value).split('T')[0].split('-').map(Number)
          return year && month && day ? new Date(year, month - 1, day) : null
        })()
        return (
          <DatePickerProvider>
            <DatePicker
              {...datePickerProps}
              title={label || ''}
              value={dateValue}
              className={className ?? 'w-full max-w-[350px]'}
              label={label}
              onChange={(newValue) => {
                onChange(newValue)
              }}
              slotProps={{
                field: { clearable: true },
                textField: {
                  error: !!errorMessage,
                  helperText: errorMessage === 'Invalid date' ? 'Data inválida' : errorMessage,
                  onBlur: onBlur,
                  fullWidth: true
                },
                actionBar: {
                  actions: ['clear']
                }
              }}
              onError={(e) => e}
              sx={{
                '.clearButton': { padding: '0', margin: '0', width: '15px', height: '15px' },
                '&& .MuiIconButton-root': { paddingLeft: '2px', paddingRight: '5px' }
              }}
            />
          </DatePickerProvider>
        )
      }}
    />
  )
}
